import { render, staticRenderFns } from "./RevisionHistoryCheckBox.vue?vue&type=template&id=61d923d2&"
import script from "./RevisionHistoryCheckBox.vue?vue&type=script&lang=ts&"
export * from "./RevisionHistoryCheckBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports